module.exports = __webpack_public_path__ + "media/src/images/demo_on-a3586df2b1a803b93ff48b89ed28d21a.png";